import React, { useState } from "react";
import { useUserContext } from "../../utils/UserContext";
import PlantillesExplorador from "./PlantillesExplorador";
import PartidesPlantilla from "./PartidesPlantilla";

function Plantilles() {
  const [activeTab, setActiveTab] = useState("plantilles");
  const [selectedPlantilla, setSelectedPlantilla] = useState(null);
  const [selectedCategoria, setSelectedCategoria] = useState(null);
  const [expandedNodes, setExpandedNodes] = useState({});
  const { empresaSeleccionada } = useUserContext();

  const handleSelectPlantilla = (plantilla) => {
    setSelectedPlantilla(plantilla);
  };

  const handleGoToPartides = () => {
    if (selectedPlantilla) {
      setActiveTab("partides");
    }
  };

  const handleTornarAPlantilles = () => {
    setActiveTab("plantilles");
  };

  if (!empresaSeleccionada) {
    return <div className="Dashboard-container"><p>Selecciona una empresa.</p></div>;
  }

  return (
    <div className="Dashboard-container">
      <div className="Dashboard-tabs">
        <button
          className={`Dashboard-tab ${activeTab === "plantilles" ? "active" : ""}`}
          onClick={() => setActiveTab("plantilles")}
        >
          Plantilles
        </button>
        <button
          className={`Dashboard-tab ${activeTab === "partides" ? "active" : ""} ${!selectedPlantilla ? "disabled" : ""}`}
          onClick={() => selectedPlantilla && setActiveTab("partides")}
          disabled={!selectedPlantilla}
        >
          Partides
        </button>
      </div>

      <div className="Dashboard-content">
        {activeTab === "plantilles" && (
          <PlantillesExplorador
            idEmpresa={empresaSeleccionada.IdEmpresa}
            selectedPlantilla={selectedPlantilla}
            onSelectPlantilla={handleSelectPlantilla}
            selectedCategoria={selectedCategoria}
            onSelectCategoria={setSelectedCategoria}
            expandedNodes={expandedNodes}
            onExpandedNodesChange={setExpandedNodes}
            onGoToPartides={handleGoToPartides}
          />
        )}
        {activeTab === "partides" && selectedPlantilla && (
          <PartidesPlantilla
            idEmpresa={empresaSeleccionada.IdEmpresa}
            plantilla={selectedPlantilla}
            onTornar={handleTornarAPlantilles}
          />
        )}
      </div>
    </div>
  );
}

export default Plantilles;
